
import Vue from "vue";
import { NewAlertDestinationsApiFunc, setAccessToken } from "@/api";
import { AlertDestination } from "@/models";

import TheTemplate from "../TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import AlertDestinationEditor from "./components/AlertDestinationEditor.vue";

export default Vue.extend({
  name: "AlertDestinationCreateScreen",

  components: {
    TheTemplate,
    BaseCloseButton,
    AlertDestinationEditor,
  },

  props: {},

  methods: {
    async createAlertDestination(
      alertDestination: AlertDestination
    ): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);
      setAccessToken(this.$auth.accessToken);
      const {
        data,
        err,
      } = await NewAlertDestinationsApiFunc().createAlertDestination(
        companyId,
        alertDestination
      );

      if (err != null) {
        this.$handleApiError(err, () => {
          this.createAlertDestination(alertDestination);
        });
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "company-alert-destinations",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
